
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "@/store";
import { MailPermissionItem } from "@/modules/mailPermission";

export default defineComponent({
    name: "MailPermissionParent",
    setup() {
        const store = useStore();
        const mailPermissionItem = MailPermissionItem.inject();

        const isMounted = ref(false);

        onMounted(async () => {
            try {
                // 基本属性情報再取得して保持
                await store.dispatch("fetchUserMailPermission");
                mailPermissionItem.setMailPermission(store.state.userMailPermission);
            } catch (e) {
                // 特に何もしない
            }
            // 子コンポーネントのonMountedが先に動くので、抑止
            isMounted.value = true;
        });

        return {
            isMounted
        };
    },
});
